import React, { useEffect, useRef } from 'react';
import { List, useSafeArea } from '@banhala/ui-kit';
import { useGoodsLikeRecommend } from '../queries/useGoodsLikeRecommend';
import { useLogDisplayCarousel } from '../hooks/useLogDisplayCarousel';
import { GoodsCarouselItem } from './GoodsCarouselItem';
import { GoodsRecommendSkeleton } from './GoodsRecommendSkeleton';
import { isAndroid } from 'shared/src/utils';
type GoodsLikeRecommendProps = {
  isExpanded: boolean;
  onContentHeightChange: (size: number) => void;
  onCarouselCountChange?: (count: number) => void;
};

const GoodsLikeRecommendContent: React.FC<GoodsLikeRecommendProps> = props => {
  const { data: goodsLikeRecommend } = useGoodsLikeRecommend();
  const { bottom } = useSafeArea();

  const { onViewableItemsChanged, viewedIndices } = useLogDisplayCarousel();
  const viewabilityConfigRef = useRef({
    itemVisiblePercentThreshold: isAndroid ? 20 : 80,
  });

  const carouselCount = goodsLikeRecommend?.carousels.length ?? 0;
  const onCarouselCountChange = props.onCarouselCountChange;
  useEffect(() => {
    onCarouselCountChange?.(carouselCount);
  }, [carouselCount, onCarouselCountChange]);

  return (
    <List
      style={{ flex: 1 }}
      data={goodsLikeRecommend?.carousels}
      onContentSizeChange={(contentWidth, contentHeight) => {
        props.onContentHeightChange(contentHeight);
      }}
      contentContainerStyle={{
        paddingBottom: bottom,
      }}
      scrollEnabled={props.isExpanded}
      onViewableItemsChanged={onViewableItemsChanged}
      viewabilityConfig={viewabilityConfigRef.current}
      renderItem={({ item: carousel, index }) => {
        return (
          <GoodsCarouselItem
            carousel={carousel}
            isLogEnabled={viewedIndices.has(index)}
          />
        );
      }}
    />
  );
};

export const GoodsLikeRecommend: React.FC<GoodsLikeRecommendProps> = props => {
  return (
    <React.Suspense fallback={<GoodsRecommendSkeleton />}>
      <GoodsLikeRecommendContent {...props} />
    </React.Suspense>
  );
};
